import React from "react";

const QuestionList = ({ items, onSelect, onEdit }) => {
	const list = items || [];
	return (
		<div className="inbox-body">
			<div className="inbox-body no-pad table-responsive">
				<table className="table table-inbox table-hover table-bordered">
					<thead>
						<tr>
							<th>sn</th>
							<th>Assessment Question</th>
							<th>Assessment </th>
							<th className="text-center">Edit/Options </th>
						</tr>
					</thead>
					<tbody>
						{list.map((item, index) => (
							<tr key={index} onClick={() => onSelect(item)}>
								<td className="inbox-small-cells">
									<div className="todo-check pull-left">
										{index + 1}
									</div>
								</td>
								<td className="view-message">
									<h5>{item.name}</h5>
									<small>
										{item.allowMultipleSelection
											? "Multiple Selection"
											: "Single Option"}
									</small>
								</td>
								<td className="view-message">
									{item.category.name}
								</td>
								<td className="view-message text-right">
									<button
										onClick={() => onEdit(item)}
										title="Update Question"
										className="mdl-button mdl-button--icon mdl-button--colored btn-default margin-right-10"
									>
										<i className="material-icons text-success">
											edit
										</i>
									</button>
									<button
										onClick={() => onSelect(item)}
										title="View Options"
										className="mdl-button mdl-button--icon mdl-button--colored btn-default margin-right-10"
									>
										<i className="material-icons text-black">
											view_list
										</i>
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				{list.length < 1 && (
					<div className="text-center m-t-10 m-b-10">
						<h4 className="text-pink">
							No Assessment Question is added yet!
						</h4>
					</div>
				)}
			</div>
		</div>
	);
};

export default QuestionList;
